// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/stylesheets/dialogs/saveAnnotation.styl
// module id = 130
// module chunks = 0